module.exports = __webpack_public_path__ + "media/images/error-red-icon-2f084338e04a713d5d822c5860be0119.svg";